module.exports = __webpack_public_path__ + "img/3_180.7606670d.png";